import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

interface EditTableDescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  description?: string;
  onSave: (description: string) => void;
}

export const EditTableDescriptionModal = ({
  isOpen,
  onClose,
  description = "",
  onSave,
}: EditTableDescriptionModalProps) => {
  const [value, setValue] = useState(description);

  useEffect(() => {
    setValue(description);
  }, [description]);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text textStyle="heading/3/medium">Edit Table Description</Text>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody>
          <Stack gap="spacing-md">
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Textarea size="lg" value={value} onChange={(e) => setValue(e.target.value)} />
            </FormControl>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Stack direction="row" gap="1">
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save
            </Button>
          </Stack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
